import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { featureFlagSelector, Features, getFeatureFlag } from '../../store/User/ConfigSlice';
import { RootState } from '../../store/Store';
import { getSeedsForGrowerV7 } from '../../store/Seeds/SeedsActions';

/**
 * Responsible for triggering and managing the redux store's loading of seed data for currently selected grower. 
 */
export const useSeedsForSelectedGrower = () => 
{
	const dispatch = useDispatch();
		
	const featureFlags = useSelector(featureFlagSelector);
	const useNewPricingService = getFeatureFlag(featureFlags, Features.UseNewPricingService);
	
	const data = useSelector<RootState, Pick<RootState['seeds']['seedsV7'], 'allSeeds' | 'availableSeeds'>>(s => 
	{
		const { allSeeds, availableSeeds } = s.seeds.seedsV7;
		return { allSeeds, availableSeeds };
	});
	const isSuccess = useSelector<RootState, boolean>(s => (
		!!s.seeds.seedsV7.allSeeds
			&& !s.seeds.seedsV7.isLoading
			&& !s.seeds.seedsV7.errorMessage
			&& s.ui.SelectedGrowerId === s.seeds.seedsV7.growerId
	));
	const isLoading = useSelector<RootState, boolean>(s => s.seeds.seedsV7.isLoading);
	const errorMessage = useSelector<RootState, string | undefined>(s => s.seeds.seedsV7.errorMessage);
	
	// Load seed data for current grower if it has not already been loaded.
	// If there are errors this will continually try to get seeds.
	useEffect(() => 
	{
		console.log('checking', { useNewPricingService, isSuccess, isLoading, errorMessage });
	
		if (!useNewPricingService || isSuccess || isLoading)
			return;
	
		console.log('dispatching');
		// This gets seeds for the currently selected grower. 
		dispatch(getSeedsForGrowerV7());
	},[isSuccess, isLoading, useNewPricingService]);
	
	return {
		useNewPricingService,
		data,
		isLoading,
		isError: !!errorMessage,
		errorMessage,
	};
};
